import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IconViewModel} from "../../../../models/IconViewModel";
import { TrendIconViewModel } from 'app/models/TrendIconViewModel';

@Component({
    selector: 'app-icon-selector',
    templateUrl: './icon-selector.component.html',
    styleUrls: ['./icon-selector.component.css'],
    standalone: false
})
export class IconSelectorComponent implements OnInit {

  @Input()
  public icons: (IconViewModel | TrendIconViewModel)[] = [];

  @Output()
  public onIconSelected: EventEmitter<IconViewModel> = new EventEmitter<IconViewModel>();

  @Input()
  public selectedIcon: number = 0;

  public icon: IconViewModel | TrendIconViewModel = null;

  public pickerOpen: boolean = false;

  public onSelect(iconId: number)
  {
    this.icon = null;
    for (let i = 0; i < this.icons.length; i++)
      if (this.icons[i].Id == iconId)
        this.icon = this.icons[i];

    this.selectedIcon = this.icon ? this.icon.Id : 0;
    this.onIconSelected.emit(this.icon as any);
  }

  constructor() {
  }

  ngOnInit() {
    this.icon = null;
    for (let i = 0; i < this.icons.length; i++)
      if (this.icons[i].Id == this.selectedIcon)
        this.icon = this.icons[i];

    const me = this;
    if (!this.icons.length)
      setTimeout(function(){ me.ngOnInit(); }, 1000);
  }
}
